<template>
    <div style="background-color: white" class="shadow-lg">
        <vue-cal
            style="height: 700px"
            :disable-views="['years', 'year', 'week', 'day']"
            locale="de"
            events-on-month-view="short"
            :events="events"
            v-on:ready="calendarReady($event)"
            v-on:view-change="onViewChange($event)"
        ></vue-cal>
    </div>
</template>

<script>
import VueCal from 'vue-cal'
import 'vue-cal/dist/i18n/de.js'
import 'vue-cal/dist/vuecal.css'
import UserStatsRepository from "../../../../repositories/LockerRoom/Stats/UserStatsRepository";
import AdminUsersRepository from "../../../../repositories/Admin/AdminUsersRepository";

export default {
    name: "StatsCalendar",
    components: {VueCal},
    data: () => ({
        currentVisibleMinTimestamp: null,
        currentVisibleMaxTimestamp: null,

        earliestTimeLoaded: null,
        latestTimeLoaded: null,

        trainingCompletionDates: [],
    }),
    props: {
      user: {
          type: Number,
          required: false,
      }
    },
    computed: {
        events() {
            let earliest = this.$date(this.earliestTimeLoaded);
            let latest = this.$date(this.latestTimeLoaded);
            let current = earliest;

            let events = [];

            while (current.isBefore(latest)) {
                let ts = current.format('YYYY-MM-DD');

                // Training completed on this day
                if(this.trainingCompletionDates.find(d => d.date === ts)) {
                    events.push({
                        start: ts,
                        end: ts,
                        title: '<i class="mdi mdi-36px text-primary shadow-sm mdi-check-decagram">',
                    })
                } else {
                    events.push({
                        start: ts,
                        end: ts,
                        title: '<i class="mdi mdi-36px text-light shadow-sm mdi-check-decagram">',
                    })
                }

                current = current.add(1, 'day')
            }

            return events;
        }
    },
    methods: {
        loadEvents(startDate = this.currentVisibleMinTimestamp, endDate = this.currentVisibleMaxTimestamp) {
            if (this.eventsInTimeSpanLoaded(startDate, endDate))
                return false;

            let q;

            if(this.user === null) {
                // User requesting own stats
                q = UserStatsRepository.getStatsBetween(startDate, endDate);
            } else {
                // Admin requesting stats of given user.
                q = AdminUsersRepository.getStatsBetween(this.user, startDate, endDate);
            }

            q.then(
                (response) => {
                    this.appendEvents(response.data);

                    // Set earliest and latest timestamps
                    if (startDate < this.earliestTimeLoaded || this.earliestTimeLoaded === null)
                        this.earliestTimeLoaded = startDate;
                    if (endDate > this.latestTimeLoaded || this.latestTimeLoaded === null)
                        this.latestTimeLoaded = endDate;
                }
            );
        },
        /**
         * Checks if events between the given Timestamps have been loaded before.
         */
        eventsInTimeSpanLoaded(startDate, endDate) {
            return startDate >= this.earliestTimeLoaded && endDate <= this.latestTimeLoaded;
        },

        /**
         * Appends events to the Event Array that are not in there yet.
         *
         * @param eventsToAppend
         */
        appendEvents(eventsToAppend) {
            eventsToAppend.forEach((eventToAppend) => {
                if (this.trainingCompletionDates.filter((event) => event.date === eventToAppend.date).length === 0) {
                    this.trainingCompletionDates.push(eventToAppend);
                }
            });
        },


        /**
         * Called whenever the view is changed.
         * @param
         */
        onViewChange(e) {
            // Set the timestamps of the current visible dates.
            this.currentVisibleMinTimestamp = e.startDate.toISOString();
            this.currentVisibleMaxTimestamp = e.endDate.toISOString();

            this.loadEvents(e.startDate.toISOString(), e.endDate.toISOString());

            // Pass the current dates to the parent so we can adapt the stats for the current Month in StatsInfo.vue
            this.$emit('date-change', {start: e.startDate.toISOString(), end: e.endDate.toISOString()});
        },
        /**
         * Called when the calendar is fully loaded.
         * @param e
         */
        calendarReady(e) {
            // Set the timestamps of the current visible dates.
            this.currentVisibleMinTimestamp = e.startDate.toISOString();
            this.currentVisibleMaxTimestamp = e.endDate.toISOString();

            this.loadEvents(e.startDate.toISOString(), e.endDate.toISOString());

            // Pass the current dates to the parent so we can adapt the stats for the current Month in StatsInfo.vue
            this.$emit('date-change', {start: e.startDate.toISOString(), end: e.endDate.toISOString()});
        },


    }
}
</script>

<style scoped>

</style>
